"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("../../../styles/colors");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    font-size: 2rem;\n    font-weight: 400;\n    color: ", ";\n    margin: 0;\n    padding: 0;\n    ", ";\n    ", ";\n    ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledPercentValue = _styledComponents["default"].h1(_templateObject(), _colors.COLOR_BRAND, function (props) {
  return props.variant === 'success' && "\n            color: ".concat(_colors.COLOR_SUCCESS, ";\n        ");
}, function (props) {
  return props.variant === 'warning' && "\n            color: ".concat(_colors.COLOR_YELLOW_1, ";\n        ");
}, function (props) {
  return props.variant === 'error' && "\n            color: ".concat(_colors.COLOR_ERROR, ";\n        ");
});

var _default = StyledPercentValue;
exports["default"] = _default;